import { IAbcComponent, StylingMode } from '../abcComponent.model';

export interface IDatepicker extends IAbcComponent {
  placeholder?: string;
  type?: DatePickerType;
  value?: any;
  decimalDigits?: Number;
  symbol?: string;
  label?: string;
  activeStateEnabled?: boolean;
  adaptivityEnabled?: boolean;
  applyButtonText?: string;
  applyValueMode?: DatePickerApplyValueMode;
  acceptCustomValue?: boolean;
  cancelButtonText?: string;
  validationMessageMode?: DateValidationMessageMode;
  validationStatus?: DateValidationStatus;
  opened?: boolean;
  openOnFieldClick?: boolean;
  pickerType?: PickerType;
  readOnly?: boolean;
  rtlEnabled?: boolean;
  disabled?: boolean;
  showAnalogClock?: boolean;
  showClearButton?: boolean;
  showDropDownButton?: boolean;
  spellcheck?: boolean;
  stylingMode?: StylingMode;
  name?: string;
  visible?: boolean;
  min?: Date | string;
  max?: Date | string;
  isConverted?: boolean;
  valueChangeEvent?: 'keyup' | 'blur' | 'change' | 'input' | 'focusout';
  useMaskBehavior?: boolean;
  setDatepickerStyle(style?: DatepickerStyle);
  setCustomDataAttributes(data?: Object);
}

export class DatepickerStyle {
  height?: string | number;
  width: string | number = '100%';
  disabled?: boolean;
  minLength?: number;
  maxLength?: number;
  popupZIndex?: number;
}

export enum DatePickerApplyValueMode {
  Instantly = 'instantly',
  UseButtons = 'useButtons',
}

export enum DateValidationMessageMode {
  Always = 'always',
  Auto = 'auto',
}

export enum DateValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
}
export enum PickerType {
  Calendar = 'calendar',
  List = 'list',
  Native = 'native',
  Rollers = 'rollers',
}

export enum DateStylingMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}

export enum DatePickerType {
  Date = 'date',
  dateTime = 'datetime',
  Time = 'time',
}
